import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MailIcon from '@mui/icons-material/Mail';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { ChangeCircle, Logout, NextPlanSharp, People } from '@mui/icons-material';
import { Outlet, Route, Routes, useNavigate } from 'react-router-dom';
import { Planes } from './planes';
import { tokenSesion } from '../utils/constant';
import { DialogCloseSesion } from '../components/DialogCloseSesion';

const drawerWidth = 240;

function AdminTemplate(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [openDialogSesion,setOpenDialogSesion] = React.useState(false);

  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  React.useEffect(()=>{
    const token =  localStorage.getItem(tokenSesion);
    if (!token){
      navigate("/");
    }
   
  },[]);

  const drawer = (
    <div>
      <DialogCloseSesion opened={openDialogSesion} onCloseDialog={e=>setOpenDialogSesion(false)} />
      <Toolbar />
      <Divider />
      <List>
        <ListItem  disablePadding>
            <ListItemButton href='/admin/clientes' >
              <ListItemIcon>
                  <People />
              </ListItemIcon>
              <ListItemText primary={"Clientes"} />
            </ListItemButton>
          </ListItem>
        {/*   <ListItem  disablePadding>
            <ListItemButton>
              <ListItemIcon>
                  <NextPlanSharp />
              </ListItemIcon>
              <ListItemText primary={"Suscripciones"} />
            </ListItemButton>
          </ListItem> */}
          <ListItem  disablePadding>
            <ListItemButton  href='/admin/planes'>
              <ListItemIcon>
                  <NextPlanSharp />
              </ListItemIcon>
              <ListItemText primary={"Planes"} />
            </ListItemButton>
          </ListItem>
          <ListItem  disablePadding>
            <ListItemButton  href='/admin/suscripciones'>
              <ListItemIcon>
                  <ChangeCircle />
              </ListItemIcon>
              <ListItemText primary={"Suscripciones"} />
            </ListItemButton>
          </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem disablePadding>
            <ListItemButton onClick={e=>setOpenDialogSesion(true)} >
              <ListItemIcon>
                <Logout />
              </ListItemIcon>
              <ListItemText primary={'Cerrar sesion'} />
            </ListItemButton>
          </ListItem>
      </List>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Administrador de chatico
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        <Toolbar />
         <main>
         
         <Outlet />
          
         </main>
      </Box>
    </Box>
  );
}

export default AdminTemplate;